import React, { Component } from 'react'
import Header from '../component/header/header';
import GuideTitle from '../component/guide/guideTitle';
import '../component/guide/guide.css';
import { Link } from 'react-router-dom';

class Guide01 extends Component {
    render() {
        const {nextPath} = this.props.guide;
        const token = JSON.parse(localStorage.getItem("userInfo"));
        return (
            <div className="gudie-wrap warning-wrap d-flex flex-column">

                <article className="header-wrap"><Header /></article>
        
                <section className="main-container d-flex flex-column">
                    <GuideTitle guide={this.props.guide} />
                    <div className="body d-flex justify-content-center scroll-wrapper">
                        <ul className="container text-container scroll-wrapper">
                            <li>▶ 본 시험의 유의사항 및 부정행위자 처리기준, 시험문제 등에 관한 비밀유지 각서 동의에 동의하지 않을 시 시험에 응시할 수 없으며 자동 결시 처리 되오니 반드시 내용을 숙지하고 동의해 주시기 바랍니다.
                            </li>
                            <li>
                                ▶ 본 시험은 교시 시작과 종료에 대한 안내방송이 없이 진행되오니 모니터에 보여지는 남은 시간 및 시작, 종료 시간 안내를 확인하여 시험시간 내에 모든 문제를 풀이하시기 바랍니다.
                            </li>
                            <li>
                                ▶ 응시자는 응시표와 신분증(주민등록증, 운전면허증, 여권, 외국국적 동포 국내거소신고증, 외국인등록증, 주민등록번호가 기재된 장애인 등록증을 지참하여 지정된 시간까지 해당 시험실에 입실하여야 합니다. 응시표는 신분증을 미지참하였을 경우, 즉시 시행 본부로 와서 조치를 받아야 합니다. 
                            </li>
                            <li>
                                ▶ 응시자는 시험의 진행에 대하여 시행본부 및 감독관의 지시에 따라야 하며, 시험을 완료하였더라도 시행본부 및 감독관 승인 없이 시험시간 도중에 퇴실하실 수 없습니다.
                            </li>
                            <li>
                                ▶ 시험 중 통신기기 및 전자기기(휴대폰, MP3, 전자사전, 계산기 등) 사용 또한 소지 적발 시 “부정행위자 등으로 간주하여 처리”될 수 있습니다. 
                            </li>
                        </ul>
                    </div>
                </section>

                <footer className="footer-wrap w-100 d-flex justify-content-center align-items-center">
                    <div className="page-btn-wrap d-flex justify-content-center align-content-center">
                        <button className="btn pre-btn">
                            <span className="icon-wrap">
                                <svg className="icon pre-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                </svg>
                            </span>
                            <b>이전</b>
                        </button>
                        <div className="page-info"><span className="current-page">1</span>&nbsp;/&nbsp;<span className="total-page">5</span></div>
                        <Link to={nextPath}>
                            <button className="btn next-btn">
                                <b>다음</b>
                                <span className="icon-wrap">
                                    <svg className="icon next-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                            </button>
                        </Link>
                    </div>
                </footer>
            </div>
        )
    }
}

export default Guide01;